export const CELL_SIZE = 40;
export const FINISH_LINE_WIDTH = 5;
export const TEAM_NAME_WIDTH = 200;
